module.exports = __webpack_public_path__ + "static/img/map.8cd692b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/map.png
// module id = 175
// module chunks = 1